import React from 'react';
import { Card , CardTitle} from 'react-bootstrap';
import SalesCustomer from './SalesCustomer';
import ProfitFunction from './ProfitFunction';
import { useParams , Link} from 'react-router-dom';
import UnitsSoldCustomer from './UnitsSoldCustomer';



const CustomerInsightsDetail = ( props) => {

    const { customerId } = useParams();
    return (
      <Card className="CustomerInsights"   header="Customer Insights">
        <CardTitle>Customer Insights</CardTitle>
        <div><SalesCustomer contactName={customerId} /></div>
        <div><Link to={'/customervolume/' + customerId}>Customer Units Sold </Link></div>
        <div><Link to={'/customermargin/' + customerId}>Customer Margin</Link></div>
        <div><Link to={'/productbreakdown/' + customerId}>See YoY Product Breakdown</Link></div>
      </Card>
    )
  }
export default CustomerInsightsDetail;
